import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';
import { ReactComponent as DownArrowSvg } from '../../../image/DownArrow2.svg';
import { ReactComponent as CheckSvg } from '../../../image/Check2.svg';

export default function SelectGenderBox(props) {
  const {
    isClickedMaleSorting,
    isClickedFemaleSorting,
    setIsClickedMaleSorting,
    setIsClickedFemaleSorting,
    pointColor
  } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const pc = pointColor || theme.primary;

  const [isClicked, setIsClicked] = useState(false);

  const ButtonRef = useRef(null);
  const SelectBoxRef = useRef(null);

  // 컴포넌트 외부 클릭시 이벤트를 받기위한 리스너 연결
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 외부 클릭시 실행
  function onClickOutSide(e) {
    if (SelectBoxRef.current !== e.target
      && !SelectBoxRef.current.contains(e.target)
      && ButtonRef.current !== e.target
      && !ButtonRef.current.contains(e.target)) {
        setIsClicked(false);
    }
  }

  return (
    <StatusBoxWrapper>
      <StatusBox ref={ButtonRef} isClicked={isClicked} $hasSelected={isClickedMaleSorting || isClickedFemaleSorting} $pointColor={pc} onClick={() => setIsClicked(!isClicked)}>
        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={isClicked ? pc : theme.text} hover='pointer'>{t('messageSend.memberSelect.filter.gender')}</Text>
        {
          (!isClickedMaleSorting && !isClickedFemaleSorting) &&
          <ArrowWrapper isClicked={isClicked}>
            <StyledArrow $isClicked={isClicked} $pointColor={pc} />
          </ArrowWrapper>
        }
        {
          (isClickedMaleSorting || isClickedFemaleSorting) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? pc : theme.text} hover='pointer'>:</Text>
        }
        {
          isClickedFemaleSorting &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? pc : theme.text} hover='pointer'>{isClickedMaleSorting ? t('messageSend.memberSelect.filter.female') + ',' : t('messageSend.memberSelect.filter.female')}</Text>
        }
        {
          isClickedMaleSorting &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? pc : theme.text} hover='pointer'>{t('messageSend.memberSelect.filter.male')}</Text>
        }
      </StatusBox>
      <SelectBox ref={SelectBoxRef} isClicked={isClicked} $isDark={isDark} $pointColor={pc}>
        <Option onClick={() => setIsClickedFemaleSorting(!isClickedFemaleSorting)}>
          <CheckBox isClicked={isClickedFemaleSorting} $pointColor={pc}>
            {
              isClickedFemaleSorting &&
              <StyledCheck $pointColor={theme.subBackground} />
            }
          </CheckBox>
          <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{t('messageSend.memberSelect.filter.female')}</Text>
        </Option>
        <Option onClick={() => setIsClickedMaleSorting(!isClickedMaleSorting)}>
          <CheckBox isClicked={isClickedMaleSorting} $pointColor={pc}>
            {
              isClickedMaleSorting &&
              <StyledCheck $pointColor={theme.subBackground} />
            }
          </CheckBox>
          <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{t('messageSend.memberSelect.filter.male')}</Text>
        </Option>
      </SelectBox>
    </StatusBoxWrapper>
  )
}

const StatusBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const StatusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: ${props => props.$hasSelected ? 'flex-start' : 'space-between'};
  align-items: center;

  padding: 0px 10px;

  box-sizing: border-box;
  width: ${props => props.$hasSelected ? 'fit-content' : '80px'};
  height: 31px;

  gap: 4px;

  border: 1px solid ${props => props.isClicked ? props.$pointColor : props.theme.buttonStroke};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.subBackground : props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const ArrowWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 10px;
  height: 10px;

  transition: all 0.3s ease-in-out;

  transform: ${props => props.isClicked ? `rotateZ(180deg)` : `rotateZ(0deg)`};
`;

const StyledArrow = styled(DownArrowSvg)`
  width: 8px;
  height: auto;
  flex-shrink: 0;

  & path {
    fill: ${props => props.$isClicked ? props.$pointColor : props.theme.text};
  }

  transition: all 0.3s ease-in-out;
`;

const SelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 0 5px;
  margin-top: 37px;

  width: fit-content;
  height: ${props => props.isClicked ? `70px` : `0px`};

  box-shadow: ${props => props.$isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border-radius: 5px;
  border: 1px solid ${props => props.isClicked ? props.$pointColor : 'transparent'};
  background-color: ${props => props.theme.subBackground};

  overflow: hidden;

  transition: all 0.3s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0;

  height: 35px;

  gap: 6px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  min-width: 16px;
  height: 16px;

  border: 1px solid ${props => props.isClicked ? props.$pointColor : props.theme.subText};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.$pointColor : props.theme.subBackground};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const StyledCheck = styled(CheckSvg)`
  width: 12px;
  height: 9px;
  flex-shrink: 0;

  color: ${props => props.$pointColor};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;
